<nav class="w-full h-20 bg-background-dark shadow-lg flex items-center justify-center">
  <img src="assets/images/logo-{{ brand }}.svg" />
</nav>
<main class="w-full h-[calc(100vh-5rem)] bg-background p-8">
  <div class="w-full max-w-5xl m-auto">
    <div class="p-12 bg-white shadow-lg rounded-2xl w-full space-y-10">
      @if (isValidCode()) {
        @if (isUserCompleted()) {
          <div class="w-full h-96 flex flex-col items-center justify-center gap-8">
            <div class="text-2xl text-zinc-900 font-semibold">
              Cadastro concluído!<br>
              Agora você pode acessar sua conta normalmente.
            </div>
            <p-button class="w-72" fluid (click)="goToLogin()">
              Acessar Conta
            </p-button>
          </div>
        } @else {
          <app-card-header  title="Complete o seu cadastro no Logame Analytics" />
          <div class="text-zinc-800">
            Recebemos seu e-mail e criamos uma conta para você! Agora, só falta completar algumas informações para finalizar o cadastro.
          </div>
          <form [formGroup]="form" class="grid grid-cols-7 gap-4" (submit)="submit()">
            <div class="flex flex-col justify-start gap-1 col-span-7">
              <label for="email" class="font-semibold">Email</label>
              <input type="text" pInputText formControlName="email" />
            </div>
            <div class="flex flex-col justify-start gap-1 col-span-7">
              <label for="name" class="font-semibold">Nome</label>
              <input
                pInputText
                id="name"
                formControlName="name"
                fluid
                autocomplete="off"
                placeholder="Insira o seu nome"
                [invalid]="form.get('name')?.dirty && form.get('name')?.errors"
                [disabled]="loading()"
              />
              @if (form.get('name')?.dirty && form.get('name')!.hasError('required')) {
                <p-message severity="error" variant="simple" size="small">Nome é obrigatório</p-message>
              }
            </div>
            <div class="flex flex-col justify-start gap-1 col-span-7">
              <label for="document" class="font-semibold">CPF</label>
              <p-inputmask
                id="document"
                formControlName="document"
                fluid
                autocomplete="off"
                placeholder="000.000.000-00"
                mask="999.999.999-99"
                [invalid]="form.get('document')?.dirty && form.get('document')?.errors"
                [disabled]="loading()"
              />
              @if (form.get('document')?.dirty && form.get('document')!.hasError('required')) {
                <p-message severity="error" variant="simple" size="small">CPF é obrigatório</p-message>
              }
            </div>
            <div class="flex flex-col justify-start gap-1 col-span-7">
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-4">
                  <label for="phone" class="font-semibold">Telefone</label>
                  <p-inputmask
                    id="phone"
                    formControlName="phone"
                    fluid
                    autocomplete="off"
                    placeholder="(99) 99999-9999"
                    mask="(99) 99999-9999"
                    [invalid]="form.get('phone')?.dirty && form.get('phone')?.errors"
                    [disabled]="loading()"
                  />
                </div>
                <div class="col-span-2 flex items-end">
                  <p-button class="w-full" fluid (click)="sendSmsValidationCode()" [loading]="loading()">
                    Enviar código de validação
                  </p-button>
                </div>
              </div>
              <div class="grid grid-cols-5 gap-2">
                <div class="col-span-2">
                  <input
                    pInputText
                    id="phone_code"
                    formControlName="phone_code"
                    fluid
                    autocomplete="off"
                    placeholder="Insira o código de seis dígitos"
                    [invalid]="form.get('phone_code_valid')?.dirty && form.get('phone_code_valid')?.errors"
                    [disabled]="loading()"
                  />
                </div>
                <div>
                  <p-button class="w-full" fluid severity="secondary" (click)="validCode()" [loading]="loading()">
                    <i class="fa-solid fa-mobile-screen-button"></i>
                    Validar telefone
                  </p-button>
                </div>
              </div>
              @if (form.get('phone')?.dirty && form.get('phone')!.hasError('required')) {
                <p-message severity="error" variant="simple" size="small">Telefone é obrigatório</p-message>
              }
              @if (form.get('phone_code_valid')?.dirty && form.get('phone_code_valid')!.hasError('requiredTrue')) {
                <p-message severity="error" variant="simple" size="small">Valide seu telefone antes de continuar</p-message>
              }
            </div>
            <div class="flex flex-col justify-start gap-1 col-span-5">
              <label for="password" class="font-semibold">Senha</label>
              <p-password
                type="password"
                inputId="password"
                formControlName="password"
                fluid
                [toggleMask]="true"
                [minlength]="8"
                [maxlength]="64"
                [feedback]="false"
                placeholder="Insira uma senha"
                [invalid]="form.get('password')?.dirty && form.get('password')?.errors"
                [disabled]="loading()"
              />
              @if (form.get('password')?.dirty && form.get('password')?.hasError('required')) {
                <p-message severity="error" variant="simple" size="small">Senha é obrigatória</p-message>
              }
            </div>
            <div class="col-span-2 flex w-full h-full items-end">
              <p-button class="w-full" fluid severity="secondary" (click)="generateStrongPassword()" [loading]="loading()">
                <i class="fa-solid fa-lock"></i>
                Gerar senha
              </p-button>
            </div>
            <div class="col-span-7">
              <ul class="password-rules">
                @for (validator of passwordValidators; track $index) {
                  <li
                    class="text-sm"
                    [ngClass]="{
                      'text-emerald-600': validator.valid(),
                      'text-rose-600': !validator.valid()
                      }"
                  >
                    @if (validator.valid()) {
                      <i class="fa-solid fa-check"></i>
                    } @else {
                      <i class="fa-solid fa-xmark"></i>
                    }
                    {{ validator.message }}
                  </li>
                }
              </ul>
            </div>
            <div class="col-span-7 flex flex-col items-center justify-center gap-2 mt-8">
              <p-button class="w-72" fluid type="submit" [loading]="loading()">
                Finalizar Cadastro
              </p-button>
              @if (form.dirty && form.status === 'INVALID') {
                <p-message severity="error" variant="simple" size="small">
                  Preencha todos os campos obrigatórios antes de continuar.
                </p-message>
              }
            </div>
          </form>
        }
      } @else {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-8">
          <div class="text-2xl text-zinc-900 font-semibold">Este link não é mais válido, solicite um novo ao seu gestor!</div>
          <p-button class="w-72" fluid (click)="goToLogin()">
            Voltar
          </p-button>
        </div>
      }
    </div>
  </div>
</main>
